import { createEndpoint } from '@/shared/models/api';
import { Informative } from '@/app/api/morgan-thermal';
import { CompanyInformation } from '@/app/api/morgan-thermal/company';

export const denyCompany = createEndpoint<Informative>(({ fetch }) => {
  return (companyId: CompanyInformation['id']) => fetch(`/Company/Deny/${companyId}`, { method: 'POST' });
});